import { useState, useEffect, useCallback } from "react";

/**
 * Generic data fetching hook.
 * @param {Function} fetchFn - async function that returns data
 * @param {Array} deps - dependency array for re-fetching
 * @param {Object} options - { enabled: true, initialData: null }
 */
const useFetch = (fetchFn, deps = [], options = {}) => {
  const { enabled = true, initialData = null } = options;
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetch = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError(null);
    try {
      const result = await fetchFn();
      setData(result);
    } catch (err) {
      setError(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch, setData };
};

export default useFetch;
